var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/scrollable_list.tsx";
const _excluded = ["scrollKey", "children", "onSeeking", "isLoading", "emptyMessage", "onLoadMore", "className", "hasMore", "placeholderComponent", "placeholderCount", "prepend", "start"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import 'react/jsx-dev-runtime';
import { Ruisseau } from '@bdxtown/ruisseau';
import React, { useRef, useCallback, useState, useImperativeHandle, useEffect } from 'react';
import { useSettings } from 'soapbox/hooks';
import LoadMore from './load_more';
import { Card, Text } from './ui';
function findNearestScrollableAncestor(el) {
  if (!el) return undefined;
  const styles = getComputedStyle(el);
  if (styles.overflowY === 'auto' || styles.overflowY === 'scroll') return el;
  return findNearestScrollableAncestor(el.parentElement);
}
const ScrollableList = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      scrollKey,
      children,
      onSeeking,
      isLoading,
      emptyMessage,
      onLoadMore,
      className,
      hasMore,
      placeholderComponent: Placeholder,
      placeholderCount = 0,
      prepend,
      start
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const settings = useSettings();
  const autoloadMore = settings.get('autoloadMore');
  const root = useRef(null);
  useImperativeHandle(ref, () => root.current);
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    if (firstRender && isLoading) {
      root.current?.scrollTo(0, 0);
    }
    if (firstRender && !isLoading) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setFirstRender(false);
    }
  }, [isLoading, firstRender]);
  const onEnd = useCallback(() => {
    if (isLoading || !autoloadMore || !hasMore) return;
    onLoadMore();
  }, [autoloadMore, hasMore, isLoading, onLoadMore]);
  const [scrollableParent, setScrollableParent] = useState(undefined);
  const findScrollableParent = useCallback(e => {
    root.current = e;
    const el = findNearestScrollableAncestor(e?.parentElement);
    setScrollableParent(el || e);
  }, []);
  return /*#__PURE__*/React.createElement(Ruisseau, _extends({
    ref: findScrollableParent
  }, rest, {
    onSeeking: onSeeking,
    start: start,
    endRatio: 0.7,
    name: scrollKey,
    className: `grow ${className}`,
    onEnd: onEnd,
    scrollElement: scrollableParent,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 5
    }
  }), prepend, children, React.Children.count(children) === 0 && !isLoading && /*#__PURE__*/React.createElement("div", {
    className: "mt-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "rounded",
    size: "lg",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 13
    }
  }, emptyMessage))), isLoading && Placeholder && Array(Math.max(1, firstRender ? placeholderCount : 1)).fill('').map(() => /*#__PURE__*/React.createElement(Placeholder, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 111
    }
  })), !autoloadMore && hasMore && /*#__PURE__*/React.createElement(LoadMore, {
    disabled: isLoading,
    onClick: onLoadMore,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 37
    }
  }));
});
export default ScrollableList;